/**
 * Messages für wartenden Spieler (Anderer ist dran)
 */

// Generisch warten
export const GENERIC = [
  "{name} ist am Zug. Chill mal kurz.",
  "{name} denkt nach. Gönn dir einen Kaffee.",
  "{name} grübelt. Geduld, Grasshopper!",
  "Warte kurz, {name} macht seinen Move.",
];

// Ich bin als Nächstes dran
export const NEXT_UP = [
  "{name} ist dran, dann du. Finger auf die Karten!",
  "{name} spielt. Du bist danach - mach dich bereit!",
  "Gleich bist du dran! {name} macht gerade.",
  "Nach {name} kommst du. Bereit machen!",
];

// Spieler hat gespielt
export const PLAYER_PLAYED = [
  "{name} hat {cards} gespielt. Weiter geht's!",
  "{name} macht einen Move mit {cards}.",
  "{name} legt {cards} vor. Mal sehen, was kommt.",
];

// Spieler hat gezogen
export const PLAYER_DREW = [
  "{name} zieht eine Karte. Der Feigling!",
  "{name} kneift und zieht. Schwächling!",
  "{name} hat keine Eier und zieht eine.",
  "{name} zieht - anscheinend zu blöd zum Spielen.",
];

// Spieler hat gepasst
export const PLAYER_PASSED = [
  "{name} passt. Hätte ich auch gemacht... nicht.",
  "{name} gibt auf und passt. Loser!",
  "{name} sagt 'Ich passe'. Wie originell.",
  "{name} passt. Keine Überraschung.",
];

// Spieler nutzt Schild
export const PLAYER_USED_SHIELD = [
  "{name} versteckt sich hinter einem Schild. Tapfer.",
  "{name} zückt das Schild. Feigling!",
  "Schild-Alert! {name} kneift mit Style.",
];

// Spieler ist fertig
export const PLAYER_FINISHED = [
  "{name} ist raus! Alle Karten weg.",
  "{name} hat's geschafft! Tschüss, Karten!",
  "{name} ist fertig. Einer weniger zum Ärgern.",
  "Muhahaha! {name} hat alle Karten abgelegt.",
];

// Spieler spielt Bombe (4+)
export const PLAYER_BOMBED = [
  "BOOM! {name} droppt eine Bombe!",
  "{name} wirft eine Bombe! Vernichtung pur.",
  "Heilige Scheiße! {name} mit der Vierer-Bombe!",
  "KABOOM! {name} zerstört alles.",
];

// Spieler spielt Flush
export const PLAYER_FLUSHED = [
  "{name} zeigt Farbe. Ein verdammter Flush!",
  "Flush von {name}! Das sitzt.",
  "{name} mit dem Farbknaller!",
];

// Spieler spielt Straße
export const PLAYER_STRAIGHTED = [
  "{name} legt eine Straße! Sauber.",
  "Straße von {name}. Das ist eine Ansage!",
  "{name} mit der Straße. Respekt.",
];

// Spieler spielt Reset (höchste 2)
export const PLAYER_RESET = [
  "RESET! {name} spielt die höchste 2!",
  "{name} wirft die Reset-Karte! Alles auf Null.",
  "Die höchste 2! {name} wischt den Tisch.",
];

// Hat mich geblockt
export const BLOCKED_ME = [
  "{name} hat dich geblockt. Das tut weh, oder?",
  "Geblockt von {name}. Autsch.",
  "{name} zeigt dir, wo der Hammer hängt.",
];

// Alle haben gepasst
export const ALL_PASSED = [
  "Alle gepasst. {name} räumt den Tisch ab.",
  "Keiner will mehr. {name} gewinnt den Stich.",
  "Pass-Festival! {name} kriegt den Pot.",
];

// Runde startet (anderer fängt an)
export const ROUND_START = [
  "Neue Runde! {name} fängt an. Warte auf deinen Zug.",
  "Runde {round}. {name} startet. Lehn dich zurück.",
  "Ok, nächste Runde. {name} macht den Anfang.",
];

// Ich bin raus, schaue zu
export const SPECTATING = [
  "Für dich ist Schluss. {name} spielt. Schau zu.",
  "Du bist raus! {name} ist dran. Entspann dich.",
  "Game Over für dich. Schau {name} beim Spielen zu.",
];

// Spieler gewinnt das Spiel
export const PLAYER_WINS = [
  "{name} gewinnt! Bitte warten.",
  "Verdammt! {name} hat gewonnen. Warte ab.",
  "{name} ist der Champion. Du nicht. Tja.",
];
